import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import '@/assets/fonts/iconfont';
import '@/assets/fonts/symbel/iconfont';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
DFWebUtilsTools.initDFWebUtilsTools('All', true, () => {
  console.log('initDFWebUtilsTools 初始化成功');
});
const persistConfig = {
  timeout: 1000, //
  key: 'root',
  storage,
  blacklist: ['router', 'initData', 'order'] // 路由不做持久化
};
if (process.env.envType === 'prd') {
  Sentry.init({
    dsn: 'https://10031741fc4741bf8dad87cf835f8b7d@sentry.dongfangfuli.com/15',
    integrations: [
      new Integrations.BrowserTracing()
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  });
}
const persistEnhancer = () => (createStore) => (reducer, initialState, enhancer) => {
  const store = createStore(persistReducer(persistConfig, reducer), initialState, enhancer);
  const persist = persistStore(store, null);
  return {
    persist,
    ...store
  };
};

export const dva = {
  config: {
    extraEnhancers: [persistEnhancer()],
    onError(err: ErrorEvent) {
      err.preventDefault();
      console.error(err.message);
    }
  }
};
// window.onload=()=>{
//   persistStore(window.g_app._store)
// }
